import React from 'react';
const InjectHTML = _ref => {
  let {
    htmlString
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: htmlString
    }
  });
};
export default InjectHTML;